import { request } from "../helpers/axios.new";

/** List active teams + member counts for the caller's company. */
export const GET_TEAMS = () =>
  request({
    url: "/team",
    method: "GET",
  });

/** Create a new team. body: { name, color? } */
export const CREATE_TEAM = (body) =>
  request({
    url: "/team",
    method: "POST",
    data: body,
  });

/** Rename / recolor. body: { name?, color? } — rename cascades to users. */
export const UPDATE_TEAM = (id, body) =>
  request({
    url: `/team/${id}`,
    method: "PUT",
    data: body,
  });

/** Soft-delete: archives the team and unassigns members. */
export const ARCHIVE_TEAM = (id) =>
  request({
    url: `/team/${id}/archive`,
    method: "PATCH",
  });

/** Bulk add/remove members. body: { add?: [userId], remove?: [userId] } */
export const ASSIGN_TEAM_MEMBERS = (id, body) =>
  request({
    url: `/team/${id}/members`,
    method: "PATCH",
    data: body,
  });

/** Per-user dropdown write. team: name or "" to unassign. */
export const SET_USER_TEAM = (userId, team) =>
  request({
    url: `/user/${userId}/team`,
    method: "PATCH",
    data: { team },
  });

/** TV leaderboard convenience — teams + memberIds in one call. */
export const GET_LEADERBOARD_TEAMS = () =>
  request({
    url: "/team/leaderboard",
    method: "GET",
  });
